<mat-divider *ngIf="!primeiroGrupo"></mat-divider>
<div class="complementGroup">
  <h3 class="complementGroupTitle">{{ grupo }}</h3>
  <div *ngFor="let complemento of complementos" [ngSwitch]="complemento.tipoComplemento">
    <app-informacao-complementar-file 
      *ngSwitchCase="'FILE'" 
      [formGroup]="formGroup!" 
      [complemento]="complemento"
      [idInscricao]="idInscricao"
      [codigoOrgao]="codigoOrgao">
    </app-informacao-complementar-file>
    <app-informacao-complementar-checkbox
      *ngSwitchCase="'CHECKBOX'"
      [complemento]="complemento"
      [formGroup]="formGroup!">
    </app-informacao-complementar-checkbox>
    <app-informacao-complementar-text *ngSwitchCase="'INPUT'" [complemento]="complemento" [formGroup]="formGroup!">
    </app-informacao-complementar-text>
  </div>
</div>
